import React from "react";
import PropTypes from "prop-types";
import getClassNameFactory from "../../../../utilities/classNames";
import classNames from "classnames";

var NavList = function NavList(_ref) {
  var children = _ref.children,
      title = _ref.title;
  var getClassName = getClassNameFactory("GlobalHeaderNavList");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames({
        noTitle: !title
      })
    })
  }, title ? /*#__PURE__*/React.createElement("h3", {
    className: "".concat(getClassName({
      descendantName: "title"
    }), " u-typographySmallCaps")
  }, title) : null, /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "items"
    })
  }, children));
};

NavList.propTypes = {
  /**
   * The contents of this `NavList`. These should be `GlobalHeader.NavItem`s.
   */
  children: PropTypes.node.isRequired,

  /**
   * The title to display above the list.
   */
  title: PropTypes.string
};
NavList.displayName = "GlobalHeader.NavList";
export default NavList;